const en = {
  // Header
  'search': 'Search...',
  'scan': 'SCAN',
  'profile': 'Profile',
  'settings': 'Settings',
  'logout': 'Logout',
  'admin': 'ADMIN',
  'administrator': 'Administrator',
  'admin.email': 'admin@admin.com',

  // Navbar
  'nav.dashboard': 'Dashboard',
  'nav.products': 'Products',
  'nav.variants': 'Variants',
  'nav.invoices': 'Invoices',
  'nav.clients': 'Clients',

  // Login
  'login.welcome': 'WELCOME',
  'login.title': 'Sign in',
  'login.subtitle': 'Access your dashboard',
  'login.username': 'Username',
  'login.username.placeholder': 'Enter your username',
  'login.password': 'Password',
  'login.password.forgot': 'Forgot password?',
  'login.password.placeholder': 'Enter your password',
  'login.remember': 'Remember me',
  'login.connecting': 'Connecting...',
  'login.signin': 'Sign in',
  'login.or': 'or continue with',
  'login.no.account': "Don't have an account?",
  'login.signup': 'Sign up',
  'login.success': 'Login successful!',
  'login.error': 'Incorrect information!',
  'login.error.generic': 'Login error!',

  // Dashboard
  'dashboard.title': 'Inventory Dashboard',
  'dashboard.subtitle': 'Manage and monitor your stock products',
  'dashboard.high_stock': 'Products High stock',

  //Dates select
  'date.today': "Today",
  'date.this_month': "This Month",
  'date.last_30_days': "Last 30 Days",
  'date.last_6_months': "Last 6 Months",
  'date.last_12_months': "Last 12 Months",
  'date.all_period': "All Time",
  'date.custom_period': "Custom Period",
  'date.select_period': "Select a Period",
  'date.cancel': "Cancel",
  'date.apply': "Apply",
  'date.months_short': ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  'date.months_long': ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  'date.days_short': ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],

  // Invoices
  'invoices.title': 'Client Invoices',
  'invoices.subtitle': 'Create, save, and print invoices while updating stock',
  'invoices.new_invoice': 'New Invoice',
  'invoices.client_name': 'Client Name',
  'invoices.client_name.placeholder': 'Enter client name',
  'invoices.invoice_code': 'Invoice Code',
  'invoices.remove_payment_confirm': 'Confirm Payment Removal',
  'invoices.invoice_code.placeholder': 'Enter invoice code',
  'invoices.logo': 'Logo',
  'invoices.product': 'Product',
  'invoices.search_product': 'Search Product',
  'invoices.no_products_found': 'No products found',
  'invoices.variant': 'Variant',
  'invoices.quantity': 'Quantity',
  'invoices.unit_price': 'Unit Price',
  'invoices.line_total': 'Total',
  'invoices.add_item': 'Add Item',
  'invoices.remove_item': 'Remove',
  'invoices.subtotal': 'Subtotal',
  'invoices.remise': 'Remise',
  'invoices.total': 'Total',
  'invoices.save': 'Save Invoice',
  'invoices.saving': 'Saving...',
  'invoices.saved': 'Invoice saved successfully',
  'invoices.print': 'Print Invoice',
  'invoices.preview_title': 'Invoice Preview',
  'invoices.preview_description': 'Review the invoice before printing or sharing.',
  'invoices.saved_invoice': 'Saved Invoice',
  'invoices.select_product': 'Select product',
  'invoices.select_variant': 'Select variant',
  'invoices.no_variant': 'No variants available',
  'invoices.product_price': 'Default product price',
  'invoices.items_count': 'Items',
  'invoices.error.loading_products': 'Unable to load products',
  'invoices.error.validation': 'Please fix the highlighted form errors',
  'invoices.error.print': 'Unable to open the print dialog. Please enable popups or try again.',
  'invoices.error.general': 'An error occurred while saving the invoice',
  'invoices.scan_barcode': 'Scan Barcode',
  'invoices.scan_barcode_placeholder': 'Scan or enter barcode...',
  'invoices.barcode_not_found': 'Product not found for this barcode',
  'invoices.item_added': 'added to invoice',
  'invoices.scan_now': 'Scan Now',
  'invoices.items_added': 'items added to invoice',
  'invoices.scan_title': 'Invoice Scanner',
  'invoices.scan_subtitle': 'Scan products to add to invoice',
  'invoices.scan_now_placeholder': 'Scan or enter barcode now...',
  'invoices.scanned_items': 'Scanned Items',
  'invoices.add_all_to_invoice': 'Add All',
  'invoices.stock': 'Stock',
  'invoices.add_to_invoice': 'Add',
  'invoices.scan_ready': 'Ready to scan',
  'invoices.scan_ready_desc': 'Use your barcode reader or manually enter a barcode to add products to this invoice.',
  'invoices.scan_footer': 'Invoice Scan Mode',
  'invoices.product_found': 'Product found',
  'invoices.recently_added': 'Recently added',
  'invoices.items_added_success': 'added successfully',
  'invoices.items_waiting': 'item(s) waiting',
  'invoices.validation.client_name': 'Client name is required',
  'invoices.validation.invoice_code': 'Invoice code is required',
  'invoices.invoice_code.draft': 'Draft code will be generated',
  'invoices.validation.product': 'Product selection or name is required',
  'invoices.validation.variant_required': 'Please select a variant for this product',
  'invoices.validation.quantity': 'Quantity must be at least 1',
  'invoices.client_phone': 'Client Phone',
  'invoices.client_phone.placeholder': 'Enter client phone',
  'invoices.status': 'Status',
  'invoices.status.not_yet': 'Not Yet',
  'invoices.status.regle': 'Paid',
  'invoices.client_history.title': 'Client History',
  'invoices.client_history.total_invoiced': 'Total Invoiced',
  'invoices.client_history.total_paid': 'Total Paid',
  'invoices.client_history.balance': 'Balance',
  'invoices.client_history.invoices': 'Invoices',
  'invoices.client_history.payments': 'Payments',
  'invoices.client_history.no_invoices': 'No invoices found',
  'invoices.client_history.no_payments': 'No payments found',
  'invoices.client_history.payment_amount': 'Payment Amount',
  'invoices.client_history.payment_date': 'Payment Date',
  'invoices.client_history.payment_note': 'Note',
  'clients.title': 'Client Accounts',
  'clients.subtitle': 'Review client invoices, unpaid amounts, payments, and add new payments.',
  'clients.total_clients': 'Total Clients',
  'clients.client_list': 'Client List',
  'clients.search_placeholder': 'Search by name or phone...',
  'clients.name': 'Name',
  'clients.phone': 'Phone',
  'clients.invoices': 'Invoices',
  'clients.total_invoiced': 'Total Invoiced',
  'clients.balance': 'Balance',
  'clients.view_history': 'View History',
  'clients.loading': 'Loading clients...',
  'clients.no_clients': 'No clients found',
  'clients.client_history_title': 'Client History',
  'clients.client_history_description': 'Review all invoices, payments and outstanding balance for the selected client.',
  'clients.total_paid': 'Total Paid',
  'clients.unpaid_amount': 'Unpaid Amount',
  'clients.invoice_list_description': 'Invoices for this client with paid and balance details.',
  'clients.invoice_code': 'Invoice Code',
  'clients.status': 'Status',
  'clients.total': 'Total',
  'clients.paid': 'Paid',
  'clients.select_invoice': 'Select invoice to pay',
  'clients.add_payment': 'Add Payment',
  'clients.payment_form_title': 'Record a payment',
  'clients.payment_form_description': 'Add a payment for a specific outstanding invoice.',
  'clients.payment_invoice': 'Invoice',
  'clients.payment_amount': 'Payment Amount',
  'clients.payment_note': 'Note',
  'clients.payment_note_placeholder': 'Optional note for this payment',
  'clients.payment_submit': 'Save Payment',
  'clients.payment_saving': 'Saving payment...',
  'clients.payment.success': 'Payment recorded successfully',
  'clients.error.loading': 'Unable to load clients',
  'clients.error.loading_details': 'Unable to load client details',
  'clients.error.payment': 'Unable to record payment',
  'clients.error.payment_amount': 'Enter a valid payment amount',
  'clients.payments': 'Payments',
  'clients.no_payments': 'No payments found',
  'clients.no_invoices': 'No invoices found',
  'clients.bulk_payment_title': 'Bulk Payment',
  'clients.bulk_payment_description': 'Distribute a payment across all unpaid invoices (oldest first)',
  'clients.bulk_payment_amount': 'Total Payment Amount',
  'clients.bulk_payment_submit': 'Distribute Payment',
  'clients.bulk_payment_saving': 'Distributing...',
  'clients.bulk_payment_success': 'Payment distributed successfully',
  'clients.bulk_payment_preview': 'Distribution Preview',
  'clients.bulk_payment_no_unpaid': 'No unpaid invoices to distribute to',
  'clients.transaction_history': 'Transaction History',
  'clients.invoice': 'Invoice',
  'clients.payment': 'Payment',
  'clients.unpaid_invoices': 'Unpaid Invoices',
  'clients.no_transactions': 'No transactions found',
  'dashboard.low_stock': 'Products low stock',
  'dashboard.stock_distribution': 'Stock Distribution',
  'dashboard.in_stock': 'In Stock',
  'dashboard.low_stock_label': 'Low Stock',
  'dashboard.out_of_stock': 'Out of Stock',
  'dashboard.product_types': 'Product Types',
  'dashboard.financial_title': 'Financial Summary',
  'dashboard.total_sales': 'Total Sales',
  'dashboard.purchase_cost': 'Purchase Cost',
  'dashboard.total_payments': 'Total Payments',
  'dashboard.total_charges': 'Charges',
  'dashboard.profit': 'Gross Profit',
  'dashboard.profit_exact': 'Net Profit',
  'dashboard.with_variants': 'With Variants',
  'dashboard.without_variants': 'Without Variants',
  'dashboard.top_selling': 'Top Selling Products',
  'dashboard.top_selling_desc': 'Best performing products by quantity sold',
  'dashboard.sold': 'Sold',
  'dashboard.no_sales_data': 'No sales data for this period',
  'dashboard.product': 'Product',
  'dashboard.price': 'Price',
  'dashboard.price_achat': 'Cost',
  'dashboard.marge': 'Marge',

  // Charts
  'charts.daily_profit': 'Net Profit per Day',
  'charts.invoice_count': 'Invoice Count',
  'charts.total': 'Total',
  'charts.invoices': 'invoices',
  'charts.no_data': 'No data available',

  // StatsMonths
  'stats.total_products': 'Total Products',
  'stats.low_stock_items': 'Low Stock Items',
  'stats.out_of_stock': 'Out of Stock',
  'stats.stock_value': 'Stock Value',
  'stats.monitor': 'Monitor',

  // CardHome
  'card.no_products': 'No Products Yet',
  'card.no_products_desc': 'Add your first product to see it here',
  'card.no_image': 'No Image',
  'card.stock': 'Stock:',
  'card.price': 'Price',
  'card.last_updated': 'Last Updated',

  // Products page
  'products.title': 'Products',
  'products.subtitle': 'Manage your inventory and stock levels',
  'products.add': 'Add Product',
  'products.sync': 'Sync Products',
  'products.syncing': 'Syncing...',
  'products.sync.title': 'Sync Products',
  'products.sync.confirm': 'This will sync all products from the external source. Continue?',
  'products.sync.start': 'Start Sync',
  'products.all_status': 'All Status',
  'products.in_stock': 'In Stock',
  'products.low_stock': 'Low Stock',
  'products.out_of_stock': 'Out of Stock',
  'products.search': 'Search by name or description...',
  'products.table.product': 'Product',
  'products.table.price': 'Price',
  'products.table.stock': 'Stock',
  'products.table.variants': 'Variants',
  'products.table.status': 'Status',
  'products.table.actions': 'Actions',
  'products.pagination.previous': 'Previous',
  'products.pagination.next': 'Next',
  'products.pagination.showing': 'Showing',
  'products.pagination.of': 'of',
  'products.pagination.to': 'to',
  'products.pagination.products': 'products',
  'products.empty.title': 'No products found',
  'products.empty.desc': 'Get started by adding your first product',
  'products.empty.add': 'Add Products',
  'products.delete.title': 'Delete Product',
  'products.delete.warning': 'This action cannot be undone',
  'products.delete.confirm': 'Are you sure you want to delete',
  'products.delete.variant_warning': 'This will also delete',
  'products.delete.variant_count': 'associated variant(s).',
  'products.delete.cancel': 'Cancel',
  'products.delete.deleting': 'Deleting...',
  'products.delete.confirm_btn': 'Delete Product',
  'products.fetch.error': 'Failed to fetch products',
  'products.delete.success': 'Product deleted successfully',
  'products.stock.title': 'Augment Stock',
  'products.stock.current': 'Current Stock',
  'products.stock.augment': 'Augment',
  'products.stock.success': 'Stock augmented successfully',
  'products.stock.error': 'Failed to augment stock',
  'products.stock.no_variant_qty': 'Add at least one variant quantity',
  'products.history.title': 'Stock History',
  'products.history.initial': 'Initial stock',
  'products.history.augmented': 'Stock augmentation',
  'products.history.sale': 'Sale',
  'products.history.client': 'Client',
  'products.history.sold': 'Sold',
  'products.history.stock_qty': 'Stock quantity',
  'products.history.no_data': 'No history available',

  // Variants page
  'variants.title': 'Product Variants',
  'variants.subtitle': 'Manage all product variants with colors, sizes, and pricing',
  'variants.add': 'Add Variant',
  'variants.table.name': 'Name',
  'variants.table.value': 'Value',
  'variants.table.type': 'Type',
  'variants.table.actions': 'Actions',
  'variants.empty.title': 'No variants found',
  'variants.empty.desc': 'Get started by adding your first variant',
  'variants.empty.add': 'Add Variant',
  'variants.modal.add.title': 'Add New Variant',
  'variants.modal.add.desc': 'Select variant type and enter details',
  'variants.modal.select_type': 'Select Variant Type',
  'variants.modal.color': 'Color',
  'variants.modal.size': 'Size',
  'variants.modal.color_name': 'Color Name',
  'variants.modal.hex': 'Hex Color Code',
  'variants.modal.hex_or_picker': 'Enter hex code or use color picker',
  'variants.modal.size_label': 'Size',
  'variants.modal.size_desc': 'Size will be used for both name and value',
  'variants.modal.cancel': 'Cancel',
  'variants.modal.adding': 'Adding...',
  'variants.modal.add_variant': 'Add Variant',
  'variants.modal.edit.title': 'Edit Variant',
  'variants.modal.edit.desc': 'Update variant details',
  'variants.modal.edit.variant_type': 'Variant Type',
  'variants.modal.edit.update': 'Update Variant',
  'variants.modal.edit.updating': 'Updating...',
  'variants.modal.delete.title': 'Delete Variant',
  'variants.modal.delete.warning': 'This action cannot be undone',
  'variants.modal.delete.confirm': 'Are you sure you want to delete the',
  'variants.modal.delete.variant_name': 'variant?',
  'variants.modal.delete.association': 'This variant may be associated with products. Deleting it will remove those associations.',
  'variants.modal.delete.deleting': 'Deleting...',
  'variants.modal.delete.confirm_btn': 'Delete Variant',
  'variants.pagination.previous': 'Previous',
  'variants.pagination.next': 'Next',
  'variants.pagination.showing': 'Showing',
  'variants.pagination.of': 'of',
  'variants.fetch.error': 'Failed to fetch variants',
  'variants.add.success': 'Variant added successfully!',
  'variants.update.success': 'Variant updated successfully!',
  'variants.delete.success': 'Variant deleted successfully!',
  'variants.add.error': 'Failed to add variant',
  'variants.update.error': 'Failed to update variant',
  'variants.delete.error': 'Failed to delete variant',
  'variants.fill.fields': 'Please fill in all fields',

  // StockScanner
  'scanner.title': 'Stock Scanner',
  'scanner.subtitle': 'Scan or enter a barcode',
  'scanner.placeholder': 'Enter barcode...',
  'scanner.ready': 'Ready to scan',
  'scanner.ready_desc': 'Use your barcode reader or manually enter to decrement stock.',
  'scanner.footer': 'Stock Management System v1.3',
  'scanner.new_stock': 'New stock:',
  'scanner.last_scan': 'Last successful scan',
  'scanner.variant': 'Variant:',
  'scanner.pcs': 'PCS',
  'scanner.scan_error': 'Failed to scan barcode',

  // AddProduct
  'product.add.title': 'Add New Product',
  'product.add.desc': 'Create a new product',
  'product.add.name': 'Product Name *',
  'product.add.name.placeholder': 'Enter product name',
  'product.add.price': 'Price *',
  'product.add.purchase_price': "Purchase Price *",
  'product.add.quantity': 'Total Quantity *',
  'product.add.quantity.placeholder': 'Enter quantity',
  'product.add.image': 'Product Image',
  'product.add.upload': 'Upload Image',
  'product.add.recommended': 'Recommended: 500x500px, JPG, PNG, GIF',
  'product.add.has_variants': 'This product has variants (color, size, etc.)',
  'product.add.variants_stock': 'Each variant will have its own stock',
  'product.add.no_variants_stock': 'Product will have a single total quantity',
  'product.add.variant_type': 'Variant Type',
  'product.add.colors_only': 'Colors Only',
  'product.add.sizes_only': 'Sizes Only',
  'product.add.colors_sizes': 'Colors & Sizes',
  'product.add.select_color': 'Select Color',
  'product.add.select_size': 'Select Size',
  'product.add.add_combination': 'Add Combination',
  'product.add.add_color': 'Add Color',
  'product.add.add_size': 'Add Size',
  'product.add.cancel': 'Cancel',
  'product.add.creating': 'Creating...',
  'product.add.create': 'Create Product',
  'product.add.fill_fields': 'Please fill in required fields',
  'product.add.add_variant': 'Please add at least one variant',
  'product.add.enter_qty': 'Please enter quantity',
  'product.add.no_combinations': 'No Variant Combinations Added',
  'product.add.no_combinations_desc': 'Add color and size combinations to create different product variants. Each combination will have its own stock.',
  'product.add.combination': 'Combination',
  'product.add.stock_qty': 'Stock Quantity *',
  'product.add.total_summary': 'Total Stock Summary',
  'product.add.across': 'Across all combinations',
  'product.add.total_units': 'Total units',
  'product.add.select_color_error': 'Please select a color',
  'product.add.select_size_error': 'Please select a size',
  'product.add.select_both_error': 'Please select both color and size',
  'product.add.color_exists': 'This color already exists',
  'product.add.size_exists': 'This size already exists',
  'product.add.combination_exists': 'This combination already exists',
  'product.add.success': 'Product created successfully',
  'product.add.operation_failed': 'Operation failed',
  'product.add.load_variants_error': 'Failed to load variants',
  'product.add.enter_stock': 'Enter stock',
  'product.add.send_to_affiliate': 'Send this product to the affiliate platform',
  'product.add.send_to_affiliate_enabled': 'This product will also be stored on the affiliate platform',
  'product.add.send_to_affiliate_disabled': 'This product will only be stored locally',
  'product.add.external_code': 'External Code',
  'product.add.external_code.placeholder': 'Enter external code',
  'product.add.external_code_variant': 'External Code',

  // EditProduct
  'product.edit.title': 'Edit Product',
  'product.edit.desc': 'Update product details',
  'product.edit.name': 'Product Name *',
  'product.edit.name.placeholder': 'Enter product name',
  'product.edit.price': 'Price *',
  'product.edit.purchase_price': "Purchase Price *",
  'product.edit.quantity': 'Total Quantity *',
  'product.edit.quantity.placeholder': 'Enter quantity',
  'product.edit.image': 'Product Image',
  'product.edit.upload': 'Upload Image',
  'product.edit.recommended': 'Recommended: 500x500px, JPG, PNG, GIF',
  'product.edit.has_variants': 'This product has variants (color, size, etc.)',
  'product.edit.variants_stock': 'Each variant will have its own stock',
  'product.edit.no_variants_stock': 'Product will have a single total quantity',
  'product.edit.variant_type': 'Variant Type',
  'product.edit.colors_only': 'Colors Only',
  'product.edit.sizes_only': 'Sizes Only',
  'product.edit.colors_sizes': 'Colors & Sizes',
  'product.edit.select_color': 'Select Color',
  'product.edit.select_size': 'Select Size',
  'product.edit.add_combination': 'Add Combination',
  'product.edit.add_color': 'Add Color',
  'product.edit.add_size': 'Add Size',
  'product.edit.cancel': 'Cancel',
  'product.edit.updating': 'Updating...',
  'product.edit.update': 'Update Product',
  'product.edit.success': 'Product updated successfully',

  // TrTableProducts
  'table.no_variants': 'No variants',
  'table.has_variants': 'Has variants',
  'table.no_image': 'No Image',
  'table.in_stock': 'in stock',
  'table.cost': 'Cost:',
  'table.selling_price': 'Selling Price:',
  'table.cost_price': 'Cost Price:',
  'table.margin': 'Margin:',
  'table.pricing': 'Pricing',
  'table.color_size': 'Color / Size',
  'table.color': 'Color',
  'table.size': 'Size',
  'table.stock': 'Stock',
  'table.no_data': 'No variant data available',
  'table.close': 'Close',
  'table.augment_stock': 'Augment Stock',
  'table.view_variants': 'View Variants',
  'table.print_stickers': 'Print QR Stickers',
  'table.edit_product': 'Edit Product',
  'table.delete_product': 'Delete Product',
  'table.total_stock': 'Total Stock:',
  'table.units': 'units',
  'table.pcs': 'PCS',
  'table.more': 'more',
  'table.variant': 'variant',
  'table.variants': 'variants',

  // StickersPrint
  'print.title': 'Print Stickers',
  'print.copies': 'Copies:',
  'print.print': 'Print',
  'print.pages': 'pages',
  'print.stickers': 'stickers',
  'print.missing_barcode': 'Missing barcode',
  'print.stock': 'Stock:',
  'print.colors': 'colors',
  'print.sizes': 'sizes',
  'print.variants': 'variants',
  'print.page': 'Page',

  // Common
  'common.colors_only_desc': 'Add different colors of the same product (e.g., Red, Blue, Black)',
  'common.sizes_only_desc': 'Add different sizes of the same product (e.g., S, M, L, XL)',
  'common.both_desc': 'Add color and size combinations (e.g., Red/S, Blue/M)',
  'common.enter_stock': 'Enter stock',
  'common.loading': 'Loading...',
  'common.error': 'Error',
  'common.success': 'Success',

  // Invoices - Additional
  'invoices.all_invoices': 'All Invoices',
  'invoices.edit': 'Edit',
  'invoices.update_success': 'Invoice updated successfully',
  'invoices.save_edit': 'Save Changes',
  'invoices.price_paye': 'Price Paid',
  'invoices.balance': 'Balance',
  'invoices.add_payment': 'Add Payment',
  'invoices.view': 'View',
  'invoices.history': 'History',
  'invoices.loading': 'Loading invoices...',
  'invoices.no_invoices': 'No invoices found',
  'invoices.add_payment_form': 'Record Payment',
  'invoices.payment_amount': 'Payment Amount',
  'invoices.payment_note': 'Note',
  'invoices.payment_note_placeholder': 'Optional payment note',
  'invoices.cancel': 'Cancel',
  'invoices.payment_submit': 'Save Payment',
  'invoices.payment_saving': 'Saving...',
  'invoices.payment_history': 'Payment History',
  'invoices.no_payments': 'No payments recorded',
  'invoices.error.payment_amount': 'Please enter a valid payment amount',
  'invoices.error.payment': 'Unable to record payment',
  'invoices.payment.success': 'Payment recorded successfully',
  'invoices.delete': 'Delete',
  'invoices.delete_confirm': 'Are you sure you want to delete this invoice?',
  'invoices.delete_success': 'Invoice deleted successfully',
  'invoices.deleting': 'Deleting...',
  'invoices.remove_payment': 'Remove',
  'invoices.payment_removed': 'Payment removed successfully',
  'invoices.yes_delete': 'Yes, Delete',
  'invoices.yes_remove': 'Yes, Remove',

  // Nav
  'nav.charges': 'Charges',
  'nav.activity_log': 'Activity Log',

  // Charges
  'charges.title': 'Charges',
  'charges.subtitle': 'Track all expenses and payments',
  'charges.add': 'Add Charge',
  'charges.edit': 'Edit Charge',
  'charges.title_label': 'Title',
  'charges.amount': 'Amount',
  'charges.date': 'Date',
  'charges.notes': 'Notes',
  'charges.actions': 'Actions',
  'charges.loading': 'Loading charges...',
  'charges.no_charges': 'No charges found',
  'charges.title_placeholder': 'Enter charge title',
  'charges.amount_placeholder': '0.00',
  'charges.notes_placeholder': 'Optional notes',
  'charges.add_success': 'Charge added successfully',
  'charges.update_success': 'Charge updated successfully',
  'charges.delete_success': 'Charge deleted successfully',
  'charges.error.loading': 'Unable to load charges',
  'charges.error.saving': 'Unable to save charge',
  'charges.error.deleting': 'Unable to delete charge',
  'charges.delete_confirm': 'Are you sure you want to delete this charge?',
  'charges.total': 'Total Charges',
  'charges.from': 'From',
  'charges.to': 'To',
  'charges.filter_btn': 'Filter',
  'charges.clear': 'Clear',
  'charges.saving': 'Saving...',

  // Activity Log
  'activity_log.title': 'Activity Log',
  'activity_log.subtitle': 'Track all actions performed in the application',
  'activity_log.loading': 'Loading activity log...',
  'activity_log.no_logs': 'No activity recorded yet',
  'activity_log.action': 'Action',
  'activity_log.description': 'Description',
  'activity_log.user': 'User',
  'activity_log.date': 'Date',
  'activity_log.details': 'Details',
  'activity_log.actions.created': 'Created',
  'activity_log.actions.updated': 'Updated',
  'activity_log.actions.deleted': 'Deleted',
  'activity_log.actions.payment': 'Payment',
  'activity_log.actions.payment_deleted': 'Payment Removed',
  'activity_log.actions.stock_augmented': 'Stock Augmented',
  'activity_log.search': 'Search',
  'activity_log.model_type': 'Type',
  'activity_log.date_sep': '→',
  'activity_log.models.product': 'Product',
  'activity_log.models.invoice': 'Invoice',
  'activity_log.models.charge': 'Charge',
  'activity_log.initial_stock': 'Initial stock',
  'activity_log.old_stock': 'Old stock',
  'activity_log.new_stock': 'New stock',
  'activity_log.added': 'Added',
  'activity_log.pcs': 'pcs',

  // Nav
  'nav.users': 'Users',
  'nav.roles': 'Roles',

  // Users
  'users.title': 'User Management',
  'users.subtitle': 'Manage system users and their roles',
  'users.add': 'Add User',
  'users.edit': 'Edit User',
  'users.name': 'Name',
  'users.email': 'Email',
  'users.password': 'Password',
  'users.password_optional': 'Password (leave blank to keep current)',
  'users.password_confirmation': 'Confirm Password',
  'users.role': 'Role',
  'users.actions': 'Actions',
  'users.select_role': 'Select a role',
  'users.no_users': 'No users found',
  'users.name_placeholder': 'Enter user name',
  'users.email_placeholder': 'Enter user email',
  'users.password_placeholder': 'Enter password',
  'users.add_success': 'User created successfully',
  'users.update_success': 'User updated successfully',
  'users.delete_success': 'User deleted successfully',
  'users.error.saving': 'Unable to save user',
  'users.error.deleting': 'Unable to delete user',
  'users.delete_confirm': 'Are you sure you want to delete this user?',
  'users.delete_confirm_btn': 'Delete User',
  'users.cancel': 'Cancel',
  'users.saving': 'Saving...',
  'users.deleting': 'Deleting...',

  // Permission Groups
  'permission_group.dashboard': 'Dashboard',
  'permission_group.products': 'Products',
  'permission_group.variants': 'Variants',
  'permission_group.invoices': 'Invoices',
  'permission_group.clients': 'Clients',
  'permission_group.charges': 'Charges',
  'permission_group.activity_logs': 'Activity Logs',
  'permission_group.users': 'Users',
  'permission_group.roles': 'Roles',
  'permission_group.scanner': 'Scanner',

  // Permissions
  'permissions.dashboard.view': 'View Dashboard',
  'permissions.products.view': 'View Products',
  'permissions.products.create': 'Create Products',
  'permissions.products.edit': 'Edit Products',
  'permissions.products.delete': 'Delete Products',
  'permissions.products.stock': 'Manage Stock',
  'permissions.variants.view': 'View Variants',
  'permissions.variants.create': 'Create Variants',
  'permissions.variants.edit': 'Edit Variants',
  'permissions.variants.delete': 'Delete Variants',
  'permissions.invoices.view': 'View Invoices',
  'permissions.invoices.create': 'Create Invoices',
  'permissions.invoices.pay': 'Record Payments',
  'permissions.invoices.edit': 'Edit Invoices',
  'permissions.invoices.delete': 'Delete Invoices',
  'permissions.clients.view': 'View Clients',
  'permissions.charges.view': 'View Charges',
  'permissions.charges.create': 'Create Charges',
  'permissions.charges.edit': 'Edit Charges',
  'permissions.charges.delete': 'Delete Charges',
  'permissions.activity_logs.view': 'View Activity Log',
  'permissions.users.manage': 'Manage Users',
  'permissions.roles.manage': 'Manage Roles',
  'permissions.scan.stock': 'Scan Stock',

  // Roles
  'roles.title': 'Role Management',
  'roles.subtitle': 'Manage roles and permissions',
  'roles.add': 'Add Role',
  'roles.edit': 'Edit Role',
  'roles.name': 'Role Name',
  'roles.name_placeholder': 'Enter role name',
  'roles.permissions': 'Permissions',
  'roles.permissions_count': 'Permissions',
  'roles.users_count': 'Users',
  'roles.actions': 'Actions',
  'roles.no_roles': 'No roles found',
  'roles.add_success': 'Role created successfully',
  'roles.update_success': 'Role updated successfully',
  'roles.delete_success': 'Role deleted successfully',
  'roles.error.saving': 'Unable to save role',
  'roles.error.deleting': 'Unable to delete role',
  'roles.delete_confirm': 'Are you sure you want to delete this role?',
  'roles.delete_confirm_btn': 'Delete Role',
  'roles.cancel': 'Cancel',
  'roles.saving': 'Saving...',
  'roles.deleting': 'Deleting...',
}

export default en
